// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CANCEL = "Zru\u0161";
export const USER_STROLLERS_ADD = "Pridaj";
export const USER_STROLLERS_ADD_NEXT_STROLLER = "Pridaj \u010fal\u0161\u00ed ko\u010d\u00edk";
export const USER_STROLLERS_ADD_STROLLER = "Pridaj ko\u010d\u00edk";
export const USER_STROLLERS_CHANGE = "Uprav";
export const USER_STROLLERS_FINISH = "Hotovo";
export const USER_STROLLERS_INIT_MESSAGE = "Tu si m\u00f4\u017ee\u0161 prida\u0165 ko\u010d\u00edky, ktor\u00e9 m\u00e1\u0161 alebo si niekedy mala.";
export const USER_STROLLERS_MY_STROLLERS = "Moje ko\u010d\u00edky";
export const USER_STROLLERS_SELECT_ENTER_SOME_CHARS = "Zadaj aspo\u0148 2 znaky z n\u00e1zvu ko\u010d\u00edka";
export const USER_STROLLERS_SELECT_NO_RESULTS = "\u017diadny v\u00fdsledok";
